import React from "react";
import heroBackground from "../../images/career/career-hero-engineers.png";
import "./CareerHero.css";

const CareerHero: React.FC = () => {
  const exploreOpportunities = () => {
    document.getElementById("open-positions")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <section
      className="career-engineering-hero"
      style={{ backgroundImage: `url(${heroBackground})` }}
      aria-labelledby="career-engineering-title"
    >
      <div className="career-engineering-hero__overlay" />

      <div className="container career-engineering-hero__container">
        <div className="career-engineering-hero__content">
          <p className="career-engineering-hero__eyebrow">
            <span>Careers at Digicomm</span>
          </p>

          <h1
            id="career-engineering-title"
            className="career-engineering-hero__title"
          >
            Engineering
            <span>Your Future</span>
          </h1>

          <p className="career-engineering-hero__lead">
            Great semiconductor products are built by engineers who are
            passionate about solving complex challenges, learning continuously,
            and working together to deliver reliable outcomes.
          </p>

          <p className="career-engineering-hero__description">
            At Digicomm Semiconductor, engineering talent can grow through
            meaningful projects, multidisciplinary collaboration, and exposure
            to cutting-edge semiconductor technologies.
          </p>

          <button
            type="button"
            className="career-engineering-hero__button"
            onClick={exploreOpportunities}
          >
            Explore Opportunities
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M5 12h14M13 6l6 6-6 6" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default CareerHero;
